<template>
  <v-col class="pa-0">
    <v-card class="border card-info mt-2">
      <div class="btn-intercom-map">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              v-bind="attrs"
              class="hover-scale-effect"
              v-on="on"
              @click="getResidentialComplexesIndividual"
            >
              <v-icon x-large color="black" class="icon-doorphone-map">mdi-home-map-marker</v-icon>
            </v-btn>
          </template>
          <span>Домофон на карте</span>
        </v-tooltip>
      </div>
      <div class="pa-4">
        <div class="flex-container" v-if="doorphone.physical_status === 6">
          <div class="mb-2">
            <span class="" style="color: crimson">
              Домофон без устройства, ожидает монтажа.
            </span>
          </div>
        </div>
        <div class="flex-container" v-if="doorphone.physical_status === 5">
          <div class="mb-2">
            <span class="" style="color: crimson">
              Установлен домофон старого образца. Ключи под заказ.
            </span>
          </div>
        </div>
        <div class="flex-container" v-if="doorphone.can_upload_open_door_sound === false">
          <div class="mb-2">
            <span style="color: #0d4092">
              Домофон в белом списке: рекламное аудио открытия двери и показания счётчиков не загружаются.
            </span>
          </div>
        </div>
        <div class="flex-container" v-if="doorphone.hidden_from_app_list">
          <div class="mb-2">
            <span class="" style="color: crimson">
              Домофон скрыт у абонентов в мобильном приложении и не отображается в списке активированных устройств.
            </span>
          </div>
        </div>
        <div class="flex-container" v-if="doorphone.hidden">
          <div class="mb-2">
            <span class="" style="color: crimson">
              Домофон скрыт из списка регистрации (активации) в мобильном приложении.
            </span>
          </div>
        </div>
        <div v-for="(item, index) in infoIntercoms1" :key="index">
          <LabelValueInfo
            :label="item.label"
            :value="item.value"
            :check="item.check"
            :br-check="item.brCheck"
            :is-check-size-small="isCheckSizeSmall"
          />
        </div>
        <div class="flex-container" v-if="doorphone.physical_status !== 5">
          <div class="label">
            <p>SIP статус</p>
          </div>
          <div class="border-left"></div>
          <div class="content">
              <span class="intercom-info">
                <v-icon x-small :color="doorphone.sip_status === '2' ? 'green' : 'red'">mdi-checkbox-blank-circle</v-icon>
                    {{ getSipStatus(doorphone.sip_status) }}
                    <v-btn
                      v-if="$checkPermission('import_sip_status_doorphone')"
                      x-small
                      color="primary"
                      icon
                      :loading="isUpdatedSip"
                      @click.prevent="updateSipStatus()"
                    >
                    <v-icon small button color="primary">mdi-cached</v-icon>
                    </v-btn>
              </span>
          </div>
        </div>
        <div class="flex-container">
          <div class="label">
            <p></p>
          </div>
          <div class="border-left"></div>
          <div class="content" v-if="doorphone.physical_status !== 5">
            <history-sip-status-dialog
              :is-check-size-small="isCheckSizeSmall"
              :sip-history="sipHistory"
            />
          </div>
        </div>
      </div>
    </v-card>
    <v-card class="border card-info mt-4">
      <div class="pa-4">
        <div v-for="(item, index) in infoIntercoms2" :key="index">
          <LabelValueInfo
            :label="item.label"
            :value="item.value"
            :check="item.check"
            :br-check="item.brCheck"
            :is-check-size-small="isCheckSizeSmall"
          />
        </div>
      </div>
    </v-card>
    <v-card class="border card-info mt-4">
      <div class="pa-4">
        <div v-for="(item, index) in infoIntercoms3" :key="index">
          <LabelValueInfo
            :label="item.label"
            :value="item.value"
            :check="item.check"
            :br-check="item.brCheck"
            :is-check-size-small="isCheckSizeSmall"
          />
        </div>
        <div class="flex-container" v-if="hasTechnicalComment">
          <div class="label">
            <p>Технический комментарий</p>
          </div>
          <div class="border-left"></div>
          <div class="content">
            <expandable-text :key="`doorphone-tech-comment-${doorphone.id}`" :text="doorphone.technical_comment" :max-length="64" />
          </div>
        </div>
      </div>
    </v-card>
  </v-col>
</template>
<script>
import ruDateFormatMixin from '@/mixins/ruDateFormat';
import LabelValueInfo from '@/components/LabelValueInfo';
import HistorySipStatusDialog from '../../../../../HistorySipStatusDialog';
import { headersSip } from '../../../consts';
import { mapActions, mapGetters } from 'vuex';
import ExpandableText from '@/components/ExpandableText';

export default {
  components: { LabelValueInfo, HistorySipStatusDialog, ExpandableText },
  mixins: [ruDateFormatMixin],
  name: 'DetailedInfo',
  props: {
    doorphone: {
      type: Object,
      required: true,
    },
    isCheckSizeSmall: {
      type: Boolean,
    },
  },
  data () {
    return {
      headersSip,
      dialogHistory: false,
      isUpdatedSip: false,
      sipHistory: [],
    };
  },
  created () {
    if (this.$checkPermission('view_sip_status_logs')) {
      this.getSipHistory(this.$route.params.id)
        .then((data) => {
          this.sipHistory = data;
        });
    }
  },
  computed: {
    ...mapGetters({
      agents: 'Agents/agents',
      roleName: 'roleName',
    }),
    contractType () {
      if (this.doorphone.contract_type === 'I') {
        return 'Индивидуальный договор';
      }
      if (this.doorphone.contract_type === 'M') {
        return 'Договор с УК';
      }
      return '';
    },
    displayTubeInstallation () {
      if (this.doorphone.possibility_phone_setup === 'IC') {
        return 'Через интернет кабель';
      }
      if (this.doorphone.possibility_phone_setup === 'Y') {
        return 'Возможна';
      }
      return 'Не возможна';
    },
    getDiapason () {
      return `${this.doorphone.diapason_from} - ${this.doorphone.diapason_to}`;
    },
    getPaymentType () {
      if (this.doorphone.payment_type === 'A') {
        return '50 руб. в месяц';
      }
      if (this.doorphone.payment_type === 'M') {
        return '0 рублей.';
      }
      if (this.doorphone.payment_type === 'G') {
        return '0 рублей.';
      }
      return '';
    },
    getAgentName () {
      const agent = this.agents.find(agent => agent.id === this.doorphone.agent_id);
      if (agent) {
        return agent.user.name;
      }
      return this.doorphone.physical_status === 5 ? 'ООО "КОМПАНИЯ ВОЛНА"' : 'Неизвестный агент';
    },
    getDispatcherPhone () {
      if (this.doorphone.dispatcher_phone) {
        return this.doorphone.dispatcher_phone;
      }
      const agent = this.agents.find(agent => agent.id === this.doorphone.agent_id);
      if (agent && agent.dispatcher_phone) {
        return agent.dispatcher_phone;
      }
      // Старые домофоны без агента — номер диспетчерской «Волны»
      if (this.doorphone.physical_status === 5) {
        return '278787';
      }
      return '';
    },
    hasTechnicalComment () {
      return Boolean(this.doorphone?.technical_comment && String(this.doorphone.technical_comment).trim());
    },
    displayTitle () {
      if (this.doorphone.type === 'A') {
        return `Домофон № ${this.doorphone.id}. Дополнительный вход`;
      }
      if (this.doorphone.type === 'G') {
        return `Домофон № ${this.doorphone.id}. Калитка`;
      }
      return `Домофон № ${this.doorphone.id}`;
    },
    infoIntercoms1 () {
      return [
        { label: 'Домофон', value: this.displayTitle, check: '1' },
        { label: 'Город', value: this.doorphone.address.split(' ')[0], check: this.doorphone.address, brCheck: true },
        { label: 'Район', value: this.doorphone.region_name, check: this.doorphone.region_name },
        { label: 'Адрес', value: this.doorphone.address, check: this.doorphone.address },
        { label: 'Подъезд', value: this.doorphone.entrance, check: this.doorphone.entrance },
        { label: 'Диапазон', value: this.getDiapason, check: this.doorphone.diapason_from },
      ];
    },
    infoIntercoms2 () {
      return [
        { label: 'Домофонная компания', value: this.getAgentName, check: '1' },
        { label: 'Номер диспетчера', value: this.getDispatcherPhone, check: this.getDispatcherPhone },
        { label: 'Номер консьержа', value: this.doorphone.concierge_number, check: this.doorphone.concierge_number },
        {
          label: 'Компания-собственник',
          value: this.doorphone.management_group_name,
          check: this.doorphone.management_group_name && this.doorphone.physical_status !== 5,
          brCheck: true,
        },
        { label: 'Управляющая компания', value: this.doorphone.management_company_name, check: this.doorphone.management_company_name, brCheck: true },
        { label: 'Статус', value: this.physicalStatus(this.doorphone.physical_status), check: this.doorphone.physical_status },
        { label: 'Дата создания', value: this.ruDateFormat(this.doorphone.created_at), check: this.doorphone.created_at },
        { label: 'Дата установки', value: this.ruDateFormat(this.doorphone.installed_at), check: this.doorphone.installed_at },
        { label: 'Сумма кв для отчёта', value: this.doorphone.diapason_file, check: this.doorphone.diapason_file && this.roleName === 'admin' },
      ];
    },
    infoIntercoms3 () {
      return [
        { label: 'АП ЭВО Лайф', value: this.getPaymentType, check: this.doorphone.payment_type },
        { label: 'АП "Домофон"', value: this.doorphone.tariff ? `${this.doorphone.tariff} руб. в месяц` : 'Тариф не указан', check: '1' },
        { label: 'Тип договора', value: this.contractType, check: this.doorphone.contract_type, brCheck: true },
        { label: 'Установка трубки', value: this.displayTubeInstallation, check: this.doorphone.possibility_phone_setup, brCheck: true },
        { label: 'Бесплатные ключи', value: this.getFreeKeys(this.doorphone.free_keys), check: this.doorphone.free_keys },
        { label: 'Предоставляет', value: this.issuanceFreeKeys(this.doorphone.issuance_free_keys), check: this.doorphone.issuance_free_keys },
        { label: 'Комментарий', value: this.doorphone.comment, check: this.doorphone.comment },
      ];
    },
  },
  methods: {
    ...mapActions({
      importSipStatus: 'Doorphone/getSipStatus',
      getSipHistory: 'Doorphone/getSipHistory',
      exportSipHistoryCsv: 'Doorphone/exportSipHistoryCsv',
      loadAllAgents: 'Agents/loadAllAgents',
    }),
    getResidentialComplexesIndividual () {
      this.$router.push({ name: 'TheMapIndividual', params: { resComById: 'none', id: this.doorphone.id } });
    },
    updateSipStatus () {
      this.isUpdatedSip = true;
      this.importSipStatus(this.doorphone.id).finally(() => {
        this.isUpdatedSip = false;
        this.getSipHistory(this.doorphone.id)
          .then((data) => {
            this.sipHistory = data;
          });
      });
    },
    getSipStatus (status) {
      switch (status) {
        case '-1': return ' (Не зарегистрировано) ';
        case '0': return ' (Не зарегистрировано) ';
        case '1': return ' (Регистрация) ';
        case '2': return ' (Зарегистрировано) ';
        case '3': return ' (Не удалось зарегистрироваться) ';
        default: return ' (Не в сети) ';
      }
    },
    physicalStatus (item) {
      switch (item) {
        case 1: return 'Установлен';
        case 2: return 'Не установлен';
        case 3: return 'Без интернет соединения';
        case 4: return 'Пусконаладка';
        case 5: return 'Старый домофон';
        case 6: return 'Ожидает монтажа';
        default: return '';
      }
    },
    getFreeKeys (item) {
      switch (item) {
        case 'OA': return '1 ключ на квартиру';
        case 'TA': return '2 ключа на квартиру';
        case 'OO': return '1 ключ на собственника';
        default: return '';
      }
    },
    issuanceFreeKeys (item) {
      switch (item) {
        case 'AG': return 'Председатель МКД / Активная группа';
        case 'MC': return 'Управляющая компания';
        case 'SD': return 'Абонентский отдел (согласно района)';
        case 'D': return 'Застройщик';
        case 'A': return 'Агент';
        case 'C': return 'Указано в комментарии';
        default: return '';
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.card-header {
  border-radius: 16px;
  text-align: center;
  height: 50px;
  padding-top: 10px;
  background-color: rgba(224, 179, 137, 0.5);
}
.border {
  border-radius: 16px;
}
.border {
  border-radius: 16px;
}
.card-info {
  background-color: white;
  color: black;
  width: auto;
  box-shadow: none;
}
.btn-intercom-map {
  position: absolute;
  top: 10px;
  right: 25px;
}
.flex-container {
  display: flex;
}

.label {
  flex: 0 0 37%;
}

.border-left {
  border-left: 1px solid #707079;
}

.content {
  padding-left: 5px;
  display: block;
  word-wrap: break-word;
}

.intercom-info {
  font-weight: 400 !important;
  padding-left: 5px;
  font-size: 15px;
  word-wrap: break-word;
  font-family: 'Montserrat', sans-serif;
}
.v-application p {
  font-weight: 600;
  margin-bottom: 8px;
  font-size: 15px;
  font-family: 'Montserrat', sans-serif;
}
.hist-but {
  cursor: pointer;
  color: cornflowerblue;
  font-weight: 400 !important;
  font-size: 15px !important;
  margin-bottom: 0 !important;
}
.btn-download-sip {
  position: absolute;
  right: 22%;
  height: 60%;
}
@media screen and (max-width: 800px) {
  .label {
    flex: 0 0 50%;
  }
  .intercom-info {
    font-size: 14px;
  }
  .content {
    padding-top: 5px;
  }
  .v-application p {
    font-size: 15px;
    padding-top: 5px;
  }
  .btn-download-sip {
    right: 11%;
  }
}
@media screen and (max-width: 800px) {
  .hist-but {}
}
@media screen and (max-width: 1000px) {
  .btn-intercom-map {
    top: 35px;
    right: 10px;
  }
}
</style>
